import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

import beerSvg from "@assets/images/beer.svg";

export const BreweryEmptyState = ({ onAddDevice }) => {
  return (
    <div className="breweryoverview--empty">
      <img
        src={beerSvg}
        alt="add-device-image"
        className="breweryoverview--empty__image"
      />
      <div
        className="breweryoverview--empty_desc"
        style={{ fontFamily: "Gotham-Book", marginBottom: "15px" }}
      >
        No devices have been set up yet, add a device by clicking the button
        below.
      </div>
      <Button
        bsStyle="primary"
        className="breweryoverview--empty__button"
        onClick={onAddDevice}
      >
        ADD DEVICE
      </Button>
    </div>
  );
};

BreweryEmptyState.propTypes = {
  onAddDevice: PropTypes.func.isRequired,
};

export default BreweryEmptyState;
